module.exports = __webpack_public_path__ + "img/preview-close.c5d548f5.svg";